import React from 'react';
import { Col, Row } from 'react-bootstrap';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import { format } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import constants from '../../../constants';

export default function TitleComponent(props) {
 return (
    <Row>
      <Col md={1} className="activeTab">{ props.viewedByAgent ===  false && <CircleIcon />}</Col>
      <Col md={10} className="pr-0 pl-2">
        <Row>
          <Col md={12} className='title-section pr-0 mb-0 mt-1'>{`${props.firstName} ${props.lastName} - ${props.title}`}</Col>
        </Row>
        <div className={'tab-date text-left mt-1'}>{props.date && format(zonedTimeToUtc(props.date, constants.serverIANATimezoneString), 'MMMM dd, yyyy - hh:mm aa')}</div>
        <div className='tab-data text-left'><span dangerouslySetInnerHTML={{ __html: props.data }}></span></div>
      </Col>
      <Col md={2}>
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Notifications/SubComponents/TitleComponent.js